var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"button",staticClass:"button",attrs:{"href":_vm.link,"target":_vm.outbound ? '_blank' : '',"rel":_vm.outbound ? 'noopener noreferrer' : ''}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }